import React from "react"
import { ButtonType } from "./types"
import clsx from "clsx"
import Link from "next/link"

export interface LinkButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonType
  isExternal?: boolean
  isNewTab?: boolean
  customPadding?: string
  customFontSize?: string
  rounded?: boolean
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  variant = "solid",
  isExternal = false,
  isNewTab = false,
  href = "",
  customPadding = "px-5 py-2",
  customFontSize = "text-sm sm:text-base",
  rounded = false,
  ...props
}) => {
  let variantStyle = ""

  switch (variant) {
    case "solid":
      variantStyle = "text-white bg-green hover:text-white"
      break
    case "solid-white":
      variantStyle = "text-black bg-white hover:text-black"
      break
    case "transparent":
      variantStyle = "text-green bg-transparent border-green lg:border border-2"
      break
    case "transparent-black":
      variantStyle = "text-black bg-transparent border-black border hover:text-black"
      break
    case "white-green":
      variantStyle = "text-green bg-white border-green border hover:text-green"
      break
    case "new-blue":
      variantStyle = "text-white bg-new-blue hover:text-white"
      break
    case "transparent-blue":
      variantStyle = "text-new-blue bg-transparent border-new-blue border hover:text-new-blue"
      break
    case "outline-blue":
      variantStyle = "text-new-blue bg-white border-new-blue border hover:text-new-blue"
      break
    default:
      break
  }

  const styles = clsx(
    "relative flex items-center justify-center font-medium hover:shadow-[0_12px_32px_0px_rgba(0,0,0,0.2)] text-center",
    !rounded && "rounded sm:font-semibold",
    variantStyle,
    customPadding,
    customFontSize,
    rounded && "rounded-lg",
    props.className
  )

  return (
    <React.Fragment>
      {isExternal ? (
        <a
          {...props}
          href={href}
          className={styles}
          target={isNewTab ? "_blank" : "_self"}
          rel="noopener noreferrer"
        />
      ) : (
        <Link href={href} {...props} className={styles} />
      )}
    </React.Fragment>
  )
}
